module.exports = __webpack_public_path__ + "img/others_21.e2fe5f23.jpg";